import { CanActivateFn, Router, CanActivate } from '@angular/router'
import { inject } from '@angular/core'
import { WindowRef } from '../providers/WindowRef'
import { AuthService } from '../services/auth.service'

export const AuthGuard: CanActivateFn = async (route, state) => {
  const winRef = inject(WindowRef)
  const authService = inject(AuthService)
  const currPath = state.url.split('/')[2] ?? "";
  const router = inject(Router)
  const pathList =["faq", "error","plans-and-pricing","", "website-terms-of-use", "connected-privacy-policy", "connected-terms-of-service", "contact-us"];
  const promiseHasSession = await winRef.nativeWindow.gigya.hasSession()
  authService.setIsLogged(promiseHasSession)
  if (!promiseHasSession) {
    authService.setIsLogged(false)
    if (pathList.some((m: string)=> m == currPath)) {
      return true;
    } else router.navigate(['/login'])
  }

  return !!promiseHasSession
}
